export default () => {
    return (
        <div>
            <h1 className="text-2xl font-semibold text-secondary p-2">Dashboard</h1>
        </div>
    );
};
